import { render, staticRenderFns } from "./UsersPayments.vue?vue&type=template&id=81cdd174&"
import script from "./UsersPayments.vue?vue&type=script&lang=js&"
export * from "./UsersPayments.vue?vue&type=script&lang=js&"
import style0 from "./UsersPayments.vue?vue&type=style&index=0&id=81cdd174&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports